export default __webpack_public_path__ + "search-examples-mapbox-mapview-thumbnail-480-b0000b2521ed4778e61027869aaa4662.png";